:host {
  display: contents;
}
.panels {
  position: relative;
  height: 100%;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  container: panels / inline-size;
}
.panels.vertical {
  flex-direction: column;
}
.panels.horizontal {
  flex-direction: row;
}
